<template>
    <div id="technology">
        <p class="title">我们的技术支持</p>
         <ul class="wow animate__animated animate__lightSpeedInLeft">
            <li v-for="(item,index) in web4" :key="index">
                <img :src="item" alt="">
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "technology",
    data() {
        return {
            web4:[require('@/assets/web/web4icon1.png'),require('@/assets/web/web4icon2.png'),require('@/assets/web/web4icon3.png'),require('@/assets/web/web4icon4.png')]
        }
    },
}
</script>

<style lang="scss">
    :root {
        --web-max-width: 1920px;
        --web-min-width: 1300px;
    } 
    #technology{
        min-width:var(--web-min-width);
        // max-width:var(--web-max-width);
        margin:0 auto;
        padding: 60px 0 86px;
        .title{
            font-size: 34px;
            font-weight: 400;
            color: #333333;
            text-align: center;
            margin-bottom: 60px;
        }
        ul{
            width: 1200px;
            margin:0 auto;
            display: flex;
            img{
                width: 280px;
            }
            li:nth-child(-n+3){
                margin-right: 27px;
            }
        }
    }
</style>